import React from 'react';

import { connect } from 'react-redux';

import {
    fetchMenuSpec,
    activateSection,
    activateSectionWithIframeWindowLocation,
    updateSideLeftMenuOpenState,
    updateSideLeftMenuPinnedOpenState,
    updateSideLeftOpenSectionId,
} from '../redux/actions';

import MainNavigationComponent from '../components/MainNavigationComponent';
import MenuSection from "../../../types/MenuSection";

const mapStateToProps = ( state ) => ( {
    menuSpec: state.mainNavigation.menuSpec,
    leftMenuState: state.mainNavigation.leftMenuState
} );

const mapDispatchToProps = dispatch => ( {
    fetchMenuSpec: () =>
    {
        dispatch( fetchMenuSpec() );
    },

    onSectionActivated: ( sectionSpec: MenuSection ) =>
    {
        dispatch( activateSection( sectionSpec ) );
    },

    onSectionActivatedIframeWindowLocation: ( currentSectionSpec: MenuSection, newSectionSpec: MenuSection ) =>
    {
        dispatch( activateSectionWithIframeWindowLocation( currentSectionSpec, newSectionSpec ) );
    },

    updateSideLeftMenuOpenState: ( isOpen: boolean ) =>
    {
        dispatch( updateSideLeftMenuOpenState( isOpen ) );
    },

    updateSideLeftMenuPinnedState: ( isPinnedOpen: boolean ) =>
    {
        dispatch( updateSideLeftMenuPinnedOpenState( isPinnedOpen ) );
    },

    updateSideLeftOpenSectionId: ( sectionId: string ) =>
    {
        dispatch( updateSideLeftOpenSectionId( sectionId ) );
    }
} );


const MainNavigationContainer = props => (
    <MainNavigationComponent {...props}/>
);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( MainNavigationContainer );
